import Title from "../components/ui/Title"
import { useState } from "react"
import Button from "../components/ui/Button"
import '../styles/ui/ui.scss'
import '../styles/pages/story.scss'

const Story = () => {

    const [page, setPage] = useState(0)
    const nextPage = () => {
        page < 2 ? setPage(page+1) : setPage(2)
    }
    const prevPage = () => {
        page > 0 ? setPage(page-1) : setPage(0)
    }

    return (
        <div className="page-container">
            <Title
                text="Story"
                size="full"
            />
            <div className="line-container">
                {
                    page === 0 ? <FirstStory/> :
                    page === 1 ? <SecondStory/> :
                    page === 2 ? <ThirdStory/> : "404"
                }
                <div className="button-list">
                    {
                        page > 0 && 
                        <Button 
                            text="previous"
                            type="gradient"
                            color=""
                            onClick={()=>{
                                prevPage()
                            }}
                        />
                    }
                    {
                        page < 2 &&
                        <Button 
                            text="next"
                            type="gradient"
                            color=""
                            onClick={()=>{
                                nextPage()
                            }}
                        />
                    }
                </div>
            </div>
        </div>
    )
}


const FirstStory = () => {
    return (
        <div className="story-wrapper">
            <p>
                Crossbell State, a small territory nestled in the western half of the continent of Zemuria...
            </p>
            <p>
            Historically the site of many fierce territorial battles between the Erebonian Empire and the Calvard Republic, Crossbell has now established itself as a booming center of trade and commerce, enjoying relative peace and prosperity.
           </p>
           <div className="story-image">
               <img src="./img/bg/crossbell-city.webp" alt="City Of Crossbell" className="story-img"/>
           </div>
           <p>
                However, just below its shining surface, trouble is brewing. Mounting pressure between the Imperial and Republican factions of its government has led to lawmakers from both sides engaging in ugly political battles and wanton corruption. At the same time, the criminal underworld is running rampant, with clashes between local mafia and foreign crime syndicates becoming more frequent. Its hands tied by corrupt superiors, the Crossbell Police Department is unable to address the rise in crime.
           </p>
        </div>
    )
}

const SecondStory = () => {
    return (
        <div className="story-wrapper second-story">
            <p>It's in the midst of all this turmoil that four young men and women join the CPD.</p>
            <div className="story-characters">
                <div className="story-character">
                    <img src="./img/story/lloyd.webp" alt="Lloyd Bannings" className="no-border"/>
                    <h1>Lloyd Bannings, a rookie detective.</h1>
                </div>
                <div className="story-character">
                    <img src="./img/story/elie.webp" alt="Elie MacDowell" className="no-border"/>
                    <h1>Elie MacDowell, the granddaughter of Crossbell's mayor.</h1>
                </div>
                <div className="story-character">
                    <img src="./img/story/tio.webp" alt="Tio Plato" className="no-border"/>
                    <h1>Tio Plato, a young researcher testing the newly-developed orbal staff.</h1>
                </div>
                <div className="story-character">
                    <img src="./img/story/randy.webp" alt="Randy Orlando" className="no-border"/>
                    <h1>Randy Orlando, a womanizing former member of the Crossbell Guardian Force.</h1>
                </div>
            </div>
        </div>
    )
}

const ThirdStory = () => {
    return (
        <div className="story-wrapper">
            <div className="story-image">
                <img src="./img/story/three.webp" alt="" />
            </div>
            <p>These unconventional rookies are assigned to the newly-established Special Support Section, a position that will bring them face-to-face with the harsh reality of their city.</p>
            <p>This is the story of these four young heroes as they work together to overcome the barriers that lie before them and bring light to those living in the shadows of their city.</p>
        </div>
    )
}

export default Story;